import {ProfileImage} from 'components/system/profile_image';
import {TextContainer} from 'components/system/text_container';
import {StarIcon} from 'icons';
import React from 'react';
import {classNames} from 'utils';
import styles from './comment.module.css';

const MAX_REPLIES_SHOWN_ON_LOAD = 4;

export const CommentBluredPlaceholder = () => {
  return (
    <div className={styles.blurredBox}>
      <div className={classNames([styles.comment, styles.topComment])}>
        <div className={styles.author}>
          <ProfileImage displayName='I' />
          <strong>Ichimoku</strong>
          <div className={styles.topCommentIcon}>
            <StarIcon color='orange' />
            <strong>Top comment</strong>
          </div>
        </div>
        <TextContainer>
          {
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit<br> sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.<br><br>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.<br><br> Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        </TextContainer>
      </div>
      <div className={classNames([styles.comment])}>
        <div className={styles.author}>
          <ProfileImage displayName='F' />
          <strong>Fibonacci</strong>
        </div>
        <TextContainer>{`Sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et <br><br>quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est`}</TextContainer>
      </div>
      <div className={classNames([styles.comment])}>
        <div className={styles.author}>
          <ProfileImage displayName='I' />
          <strong>Ichimoku</strong>
        </div>
        <TextContainer>
          Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
          laudantium 😀
        </TextContainer>
      </div>
      <div className={classNames([styles.comment])}>
        <div className={styles.author}>
          <ProfileImage displayName='F' />
          <strong>Fibonacci</strong>
        </div>
        <TextContainer>{`Sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et <br><br>quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est`}</TextContainer>
      </div>
    </div>
  );
};

type Props = {
  comment: UserComment;
  showVote?: boolean;
  showChildren?: boolean;
  showActions?: boolean;
  onCreate?: (path: number[], comment: UserComment) => void;
  onChange?: (path: number[], comment: UserComment) => void;
  onDelete?: (path: number[], comment: UserComment) => void;
};
